// import one from "../assets/svg/projects/one.svg";
// import two from "../assets/svg/projects/two.svg";
// import three from "../assets/svg/projects/three.svg";
// import four from "../assets/svg/projects/four.svg";
// import five from "../assets/svg/projects/five.svg";
// import six from "../assets/svg/projects/six.svg";
// import seven from "../assets/svg/projects/seven.svg";
// import eight from "../assets/svg/projects/eight.svg";
// import udemy from "../assets/png/udemy2.jpeg";

export const projectsData = [
  {
    id: 1,
    projectName: "Nykaa Clone",
    projectDesc: [
      `Nykaa is an E-commerce company have domain around cosmetic's`,
      [
        "Front-End Using React",
        "Back-End using Node Express",
        "Database using MongoDB"
      ]
    ],
    tags: ["React", "Express", "MongoDB"],
    code: "https://github.com/OfficialSiddharthBisht/nykaa-clone",
    demo: "https://nykaa-clone-siddharth.netlify.app/",
    image:
      "https://th.bing.com/th/id/OIP.eiIhwuSOWJvAgFDj0XOVtAHaDS?pid=ImgDet&rs=1"
  },
  {
    id: 2,
    projectName: "Tesla Clone",
    projectDesc: [
      "Tesla is accelerating the world's transition to sustainable energy with electric cars, solar and integrated renewable energy solutions for homes and businesses.",
      ["Solo Project", "Made Tesla Landing Page"]
    ],
    tags: ["React", "Redux"],
    code: "https://github.com/OfficialSiddharthBisht/tesla-clone",
    demo: "https://tesla-clone-rho.vercel.app/",
    image:
      "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.f9OvjIR-m7YLjEqv-wJL-QHaJq%26pid%3DApi&f=1"
  },
  {
    id: 10,
    projectName: "E Commerce Backend NodeJS",
    projectDesc: [
      "E commerce Backend with all functionalities of an e commerce site",
      ["Solo Project", "Admin, User, Cart ,Filters, Search, Products, Orders"]
    ],
    tags: ["MongoDB", "Express"],
    code: "https://github.com/OfficialSiddharthBisht/e-commerce-backend",
    demo: "https://github.com/OfficialSiddharthBisht/e-commerce-backend/wiki",
    image:
      "https://th.bing.com/th/id/OIP.ndX5N2ZGLTLjQWV8gier8QHaFj?w=226&h=180&c=7&r=0&o=5&dpr=1.25&pid=1.7"
  },
  {
    id: 3,
    projectName: "Discovery+ Clone",
    projectDesc: [
      "Discovery+ is a streaming service.",
      [
        "JSON Server + API Endpoints",
        "Data Fetching using API",
        "Search Series Functionality"
      ]
    ],
    tags: ["HTML", "CSS", "JavaScript"],
    code: "https://github.com/OfficialSiddharthBisht/Discovery-Clone",
    demo: "https://officialsiddharthbisht.github.io/Discovery-Clone/",
    image:
      "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.dBgoyEfYljjeyDFAxa-twwHaEU%26pid%3DApi&f=1"
  },
  // {
  //   id: 5,
  //   projectName: "Expedia Travel Clone",
  //   projectDesc: [
  //     "Expedia Group, Inc. is an American online travel shopping company for consumer and small business travel.",
  //     [
  //       "Version Control Using GIT",
  //       "Made Multiple Pages",
  //       "Footer Using Modules",
  //     ],
  //   ],
  //   tags: ["HTML", "JavaScript", "CSS"],
  //   code: "https://github.com/OfficialSiddharthBisht/Expedia-Travel-Clone",
  //   demo: "https://officialsiddharthbisht.github.io/Expedia-Travel-Clone/",
  //   image:
  //     "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse3.mm.bing.net%2Fth%3Fid%3DOIP.Y2gvAVgkMcupwaefIabawQHaE6%26pid%3DApi&f=1",
  // },
  // {
  //   id: 6,
  //   projectName: "Weather App",
  //   projectDesc: [
  //     "A weather app that shows the weather of any city in the world.",
  //     [
  //       "Solo Project",
  //       "Made Tesla Landing Page",
  //     ],
  //   ],
  //   tags: ["HTML" , "CSS" ,"JS"],
  //   code: "https://github.com/OfficialSiddharthBisht/summer-project-weather-app",
  //   demo: "https://officialsiddharthbisht.github.io/summer-project-weather-app/",
  //   image:
  //     "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse3.mm.bing.net%2Fth%3Fid%3DOIP.1VkjnHLGX38a5zirASIYWAHaFj%26pid%3DApi&f=1",
  // },
  // {
  //   id: 7,
  //   projectName: "Amazon Clone",
  //   projectDesc: [
  //     "Amazon Clone In Progress",
  //     [
  //       "Solo Project",
  //       "React JS",
  //       "Firebase"
  //     ],
  //   ],
  //   tags: ["React"],
  //   code: "https://github.com/OfficialSiddharthBisht/amazon-clone",
  //   demo: "https://amazon-clone-sandy-three.vercel.app/",
  //   image:
  //     "https://www.itprotoday.com/sites/itprotoday.com/files/amazon-logo-on-corner-of-building.jpg",
  // },
  // {
  //   id: 8,
  //   projectName: "Cafe's Menu Application",
  //   projectDesc: [
  //     "A simple and minimilist menu application built in React JS.",
  //     [
  //       "Solo Project",
  //       "React JS",
  //     ],
  //   ],
  //   tags: ["React"],
  //   code: "https://github.com/OfficialSiddharthBisht/qris-internship-assignment-cafe-menu",
  //   demo: "https://qris-internship-assignment-cafe-menu.vercel.app/",
  //   image:
  //     "https://live.staticflickr.com/591/31374175083_6acbd2697b_b.jpg",
  // },
  {
    id: 4,
    projectName: "Lumen 5 Clone",
    projectDesc: [
      `Lumen5 is a video creation platform powered by A.I. that enables anyone to create engaging video content`,
      ["Team Lead", "Responsive landing page", "All Video Elements"]
    ],
    tags: ["JavaScript", "Tailwind", "HTML"],
    code: "https://github.com/OfficialSiddharthBisht/Lumen5-Video-Maker-Clone",
    demo: "https://officialsiddharthbisht.github.io/Lumen5-Video-Maker-Clone",
    image:
      "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2F50wheel.com%2Fwp-content%2Fuploads%2F2018%2F05%2Flumen5-3.png&f=1&nofb=1"
  }
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
